<template>
    <div class="custom-main custom-theme">
        <a-spin :spinning="loading" tip="正在提交数据....">
            <a-row :gutter="{ xs: 8, sm: 16, md: 16}">
                <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
                <a-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :xxl="11">
                    <a-form :form="form" layout="horizontal" style="margin-top: 20px">
                        <a-row>
                            <a-col span="8">
                                <a-form-item label="出库类型" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-select v-decorator="['type', {rules: [{ required: true, message: '出库类型必须填写!' }], initialValue: init.type }]" placeholder="请选择出库类型">
                                        <a-select-option v-for="item in init.types" :key="item.name" :value="item.name">{{item.value}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col v-if="init.actionType == '1'" span="8">
                                <a-form-item label="供应商" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-select v-decorator="['supplierId', {rules: [{ required: true, message: '供应商必须填写!' }], initialValue: record.supplierId }]" placeholder="请选择供应商">
                                        <a-select-option v-for="item in init.suppliers" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col span="8">
                                <a-form-item label="单据号" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                                    <a-input :disabled="true" v-decorator="['docNo', {initialValue: record.docNo }]" placeholder="系统自动生成单据号"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                        <a-row v-if="false">
                            <a-col span="16">
                                <a-form-item label="备注" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                                    <a-textarea v-decorator="['remark', {initialValue: record.remark }]" placeholder="请输入备注"/>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-form>
                    <a-row>
                        <a-col span="1">
                        </a-col>
                        <a-col span="23">
                            <a-tabs default-active-key="1"  size="small" style="min-height: 260px;">
                                <a-tab-pane key="1" tab="待出库药品">
                                    <a-table size="small" :columns="drugGrid.columns" rowKey="id" :data-source="drugGrid.datas"  :pagination="false" style="padding:4px;">
                                        <a-form-item slot="outSlot" slot-scope="text, record" style="margin-bottom: 1px!important;width:100%">
                                            <a-input-number :min="0.01" v-model="record.outQty" :defaultValue="record.currQty" />
                                        </a-form-item>
                                        <span slot="Operate" slot-scope="text, record, index">
                                                <a href="javascript:;" @click="()=>deleteDrugs(index)">删除</a>
                                            </span>
                                    </a-table>
                                </a-tab-pane>
                                <a-button v-if="false" class="custom-primary-btn" slot="tabBarExtraContent" type="primary" @click="addDrugAction()">添加药品</a-button>
                            </a-tabs>
                        </a-col>
                    </a-row>
                    <div class="button-container">
                        <div>
                            <a-button icon="double-left" style="float:right; margin-left: 24px;" @click="goBack">返回</a-button>
                            <a-button icon="save" type="primary" style="float:right; margin-left: 24px;" @click="()=>submitStockOut()">出库登记</a-button>
                        </div>
                    </div>
                </a-col>
                <a-col :xs="11" :sm="11" :md="11" :lg="11" :xl="11" :xxl="11">
                    <a-form :form="search.form" class="ant-advanced-search-form">
                        <a-row class="searchrow nobottom-border width-style-auto" style="padding-bottom: 0px" >
                            <a-form-item label="供应商">
                                <a-select v-model="search.supplierId">
                                    <a-select-option value="">--请选择--</a-select-option>
                                    <a-select-option v-for="item in init.suppliers" :key="item.id" :value="item.id">
                                        {{item.name}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item label="单据号">
                                <a-input v-model="search.docNo" placeholder="请输入入库单据号模糊检索"/>
                            </a-form-item>
                        </a-row>
                        <a-row  class="searchrow nobottom-border width-style-auto" style="padding-bottom: 0px">
                            <a-form-item label="药品名称">
                                <a-input v-model="search.keyword" placeholder="请输入药品关键字模糊检索"/>
                            </a-form-item>
                            <a-form-item>
                                <a-button icon="search" @click="searchAction" style="margin-right: 4px;">检索</a-button>
                            </a-form-item>
                        </a-row>
                    </a-form>
                    <a-row class="search"></a-row>
                    <a-table size="middle" :columns="grid.columns" :loading="grid.loading"
                             rowKey="id" :dataSource="grid.data" :scroll="{ x: '100%' }" key="id" :pagination="grid.pagination" :customRow="handleClickRow" @change="gridChangeAction">

                    </a-table>
                </a-col>
                <a-col :xs="1" :sm="1" :md="1" :lg="1" :xl="1" :xxl="1">&nbsp;</a-col>
            </a-row>
        </a-spin>
        <a-modal title="添加药品" :visible="addDrugModal.visible" width="50%" @cancel="closeDrugModal" @ok="addDrugToList()">
          <a-spin :spinning="loading" tip="正在提交数据....">
            <a-form :form="addDrugModal.form" layout="horizontal" style="margin-top: 20px">
              <a-row>
                <a-col span="24">
                  <a-form-item label="药品选择" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }">
                    <a-select ref="drugSearch"
                              show-search
                              :default-active-first-option="false"
                              :show-arrow="false"
                              :filter-option="false"
                              :not-found-content="null"
                              @search="drugSearch"
                              @select="drugSelect"
                              placeholder="请输入关键字搜索">
                      <a-select-option v-for="item in addDrugModal.drugs" :key="item.id" :value="item.id">{{item.text}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="24">
                  <a-form-item label="所选药品" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 18, xl: 18, xxl: 18 }">
                    <span v-if="addDrugModal.drug.id==null ||addDrugModal.drug.id=='' " class="drugSpan">您当前还未选择药品</span>
                    <span v-if="addDrugModal.drug.id!=null && addDrugModal.drug.id!='' " class="drugSpan">[药品名称]{{addDrugModal.drug.name}},[分类]{{addDrugModal.drug.typeName}},[销售单位]{{addDrugModal.drug.salesUnit}},</span>
                  </a-form-item>
                </a-col>
                <a-col span="12">
                  <a-form-item label="采购单位" :label-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12 }" :wrapper-col="{sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }">
                    <a-select ref="stockUnit"  v-decorator="['unitIndex', {rules: [{ required: true, message: '采购单位必须填写!' }], initialValue: addDrugModal.drug.unitIndex||0}]" placeholder="剂量单位">
                      <a-select-option v-for="(item,index) in addDrugModal.drug.units" :key="item.index" :value="item.index">{{item.name}}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col span="12">
                  <a-form-item label="出库数量" :label-col="{sm: 24, md: 12, lg: 6, xl: 6, xxl: 6 }" :wrapper-col="{sm: 24, md: 12, lg: 12, xl: 12, xxl: 12}">
                    <a-input-number ref="stockQty"  :min="0.1" v-decorator="['stockQty', {rules:[{ required: true, message: '出库数量不能为空!' }], initialValue: addDrugModal.drug.stockQty||'1' }]" placeholder="请输入出库数量"/>
                  </a-form-item>
                </a-col>
              </a-row>

            </a-form>
          </a-spin>

        </a-modal>
    </div>
</template>

<script>
  import moment from "moment";

  export default {
    name: "StockOutCreate",
    data(){
      return{
        loading : false,
        form: this.$form.createForm(this),
        current: {},
        currOrgan:{},
        init: {
          actionType:'',    //1-采购退货出库  2-盘点出库 3-其他出库 4-报损出库
          type : '',
          types: [],
          suppliers:[],
        },
        record:{outDate:''},
        drugGrid:{
          columns: drugColumn,
          datas: []
        },
        search: {
          form: this.$form.createForm(this),
          keyword : '',
          docNo: '',
          startDate:'',
          endDate:'',
          supplierId:''
        },
        addDrugModal:{
          visible:false,
          drugAmt : 0,
          drugs:[],
          drug :{},
          form: this.$form.createForm(this),
        },
        grid: {
          loading: false,
          columns: columns,
          data: [],
          selections:[],
          pagination: this.$pagination
        }
      }
    },
    mounted() {
      let self = this;

      this.current = JSON.parse(localStorage.getItem("curruser"));

      let actionType = this.$route.query.actionType||'';
      self.init.actionType = actionType;
      if(actionType == '1'){//采购退货出库
        self.init.types = [{name:'PURCHASE_R_OUT',value:'采购退货出库'}];
        self.init.type = 'PURCHASE_R_OUT'
      }else if(actionType == '2'){//盘亏出库
        self.init.types = [{name:'INVENTORY_LOSS',value:'盘亏出库'}];
        self.init.type = 'INVENTORY_LOSS'
      }else if(actionType == '3'){//报损出库
        self.init.types = [{name:'BREAKAGE_OUT',value:'报损出库'}];
        self.init.type = 'BREAKAGE_OUT'
      }else{//其他出库
        self.init.types = [{name:'SALE_OUT',value:'销售出库'},{name:'ALLOCATION_OUT',value:'调拨出库'},{name:'OTHER_OUT',value:'其他出库'}];
        self.init.type = ''
      }

      this.getSuppliers('', 20, function (res) {
        self.init.suppliers = res;
      })

      this.getCurrOrgan();

      if(actionType == '1'){
        this.getOrganConfig(this.current.organId,'106',function (res) {
          if(res||'' == '1'){
            self.confirmTitle = '当前系统配置了出库审核流程，在审核完成之前可以继续修改出库登记信息'
          }else{
            self.confirmTitle = '当前系统配置了出库自动审核功能，出库登记后将不能进行登记信息修改，请谨慎操作'
          }
        });
      }else{
        self.confirmTitle = '您确认要进行出库操作吗？'
      }

    },

    methods:{
      /**
       * 获取当前用户所属机构
       */
      getCurrOrgan:function(){
        let self = this;
        this.$axios.get('/api/clinic/' + self.current.organId + '/mine').then(function (res) {
          if(res.msg.flag == 0){
            self.currOrgan = res.biz;
          }
        })
      },

      buildParams:function(){
        return {
          'entity.docNo' : this.search.docNo, 'entity.supplierId':this.search.supplierId, 'entity.stock' : true, 'entity.keyword' : this.search.keyword
        };
      },
      /**
       * 搜索按钮点击动作
       */
      searchAction:function () {
        Object.assign(this.grid, {pagination: Object.assign(this.grid.pagination, {current: 1})});
        let params = Object.assign(this.buildParams(), {start: 0, length: this.grid.pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       * 分页条操作
       */
      gridChangeAction: function (pagination, filters, sorter) {
        Object.assign(this.grid, {pagination: pagination});
        let params = Object.assign(this.buildParams(), {start: (pagination.current -1 ) * pagination.pageSize, length: pagination.pageSize});
        this.loadGrid(params);
      },

      /**
       * 查询药品
       */
      loadGrid:function(params){
        const self = this;
        self.grid.loading = true;
        self.$axios.get('/api/clinic/stockin/drugs', {params: params}).then(function(res){
          self.grid.loading = false;
          if(res.msg.flag == 0){
            if(null == res.biz || res.biz.empty){
              self.$message.info({content: res.msg.message, duration: 2});
              Object.assign(self.grid, {data: [], pagination: Object.assign(self.grid.pagination, {total: 0})});
            }else{
              let list = res.biz.data;
              list.forEach(function (item) {
                item.recordId = item.id;
              })
              Object.assign(self.grid, {data: res.biz.data, pagination:Object.assign(self.grid.pagination, {total: res.biz.count})});
            }
          }else{
            self.$message.error({content: res.msg.message, duration: 2});
          }
        },function(){
          self.grid.loading = false;
        });
      },

      deleteDrugs:function(index){
        this.drugGrid.datas.splice(index,1);
      },

      handleClickRow:function(record, index){

        let self = this;
        return{
          on:{
            dblclick:()=>{
              console.info('双击事件')
              let list = self.drugGrid.datas||[];
              let exists = false;
              for(let item of list){
                if(record.id == item.id){
                  self.$message.error({content:'该库存药品已添加到列表，不能重复添加'});
                  exists = true;
                  break;
                }
              }
              if(!exists){
                self.drugGrid.datas.unshift(record);
              }
            }
          }
        }
      },


      submitStockOut:function () {
        let self = this;

        this.form.validateFields((err, values) => {
          if(!err){
            let params = {id:self.record.id||'', type:values.type||'',supplierId:values.supplierId||'', outDate:values.outDate,remark:values.remark };
            let items=[];
            if(undefined != self.drugGrid.datas && null != self.drugGrid.datas && self.drugGrid.datas.length > 0){
              let _stockUnit = {};
              for(let item of self.drugGrid.datas){
                item.units.forEach(function (unit) {
                  if(unit.name == item.unit){
                    _stockUnit = unit;
                  }
                })
                items.push({docDrugId:item.recordId, drugId:item.drugId, stockUnit:_stockUnit, stockQty:item.outQty});
              }
            }
            if(items.length == 0){
              self.$message.error({content:'请至少录入一条药品出库信息', duration:2});
              return;
            }
            params.drugs = items;

            self.$confirm({
              title: self.confirmTitle,
              okText:'出库登记',
              onOk() {
                self.loadTip='正在保存出库单信息,请稍候...';
                self.loading = true;
                self.$axios.post('/api/clinic/stockout/registered', params).then(function(res){
                  self.loading = false;
                  if(res.msg.flag == 0){
                    self.$message.success({content: '出库单保存成功.', duration: 2});
                    self.form.resetFields();
                    self.drugGrid.datas = [];
                    self.$router.go(-1)
                  }else{
                    self.$message.error({content: res.msg.message, duration: 2});
                  }
                },function(res){
                  self.loading = false;
                });
              },
            });


          }
        });
      },

      /**
       * 药品搜索事件
       */
      drugSearch:function(value){
        let self = this;
        self.addDrugModal.drugs = [];
        if(value==null || value == '' || value.length<2){
          return;
        }
        self.$axios.get('/api/clinic/drug/search',{params:{keyword:value, organId:self.currOrgan.id}}).then(function (res) {
          if(res.msg.flag == 0){
            let drugs = res.biz||[];
            drugs.forEach(function (item) {
              item.text = item.hq ? '[总部]' : '[自定义]';
              item.text = item.text +'/' + item.name;
              if(item.alias!=null && item.alias.length>0){
                for(let alia of item.alias){
                  item.text = item.text +'/' + alia;
                }
              }

              if(item.typeName!=null && item.typeName!=''){
                item.text = item.text +'/' + item.typeName;
              }
              if(item.form!=null && item.form!=''){
                item.text = item.text +'/' + item.form;
              }
              if(item.manufacturer!=null && item.manufacturer!=''){
                item.text = item.text +'/' + item.manufacturer;
              }
            })
            self.addDrugModal.drugs = drugs;
          }
        })
      },

      /**
       * 药品选中事件
       */
      drugSelect:function(id){
        let self = this;
        for(let item of this.addDrugModal.drugs){
          if(id == item.id){
            let _units = [];
            let index = 0;
            for(let unit of item.units){
              _units.push({index : index, name:unit.name, unit:unit});
              index++;
            }
            this.addDrugModal.drug ={id:new Date().getTime(), recordId:'', drugId:item.id, currQty:item.stockQty, name:item.name, typeName:item.typeName, salesUnit:item.salesUnit, units:_units ,manufacturer:item.manufacturer };
            console.info(this.addDrugModal.drug)
            break;
          }
        }
      },

      /**
       * 添加药品
       */
      addDrugAction:function(){
        this.addDrugModal.visible = true;
      },
      /**
       * 关闭添加药品窗口
       */
      closeDrugModal:function(){
        this.addDrugModal.visible = false;
      },

      /**
       * 添加药品到待出库药品列表中
       */
      addDrugToList:function(){
        let self = this;
        this.addDrugModal.form.validateFields((errs,values)=>{
          if(!errs){
            let _drug = this.addDrugModal.drug;
            let list = self.drugGrid.datas||[];
            let exists = false;
            for(let item of list){
              if(_drug.drugId == item.drugId){
                self.$message.error({content:'该库存药品已添加到列表，不能重复添加'});
                exists = true;
                break;
              }
            }

            if(!exists){
              let _record = {id:new Date().getTime(),recordId:'', drugId:_drug.drugId, name: _drug.name, currQty:_drug.currQty, outQty:values.stockQty, unit:_drug.units[values.unitIndex].unit.name, units:_drug.units}
              self.drugGrid.datas.unshift(_record);
              self.addDrugModal.drug = {};
            }
            self.$confirm({
              title: '药品添加成功,是否继续添加?',
              onOk() {
              },
              onCancel() {
                self.addDrugModal.visible = false;
              }
            });
          }
        })
      },

      children:function (e) {
        const self = this;
        let result =[];
        if(undefined != e.children && null != e.children && e.children.length > 0){
          e.children.forEach(function (m){
            result.push({title:m.name, value:m.id, key:m.id, children:self.children(m)});
          });
        }
        return result;
      },

      goBack:function (){
        this.$router.go(-1)
      }
    }
  }

  const drugColumn = [
    {
      title: '药品名称',
      dataIndex : 'name',
      key: 'name',
      align: 'center',
      width: 100
    },{
      title: '生产批号',
      dataIndex : 'batchNo',
      key: 'batchNo',
      align: 'center',
      width: 90
    },{
      title: '当前库存',
      dataIndex : 'currQty',
      key: 'currQty',
      align: 'center',
      width: 90
    },{
      title: '退货单位',
      dataIndex : 'unit',
      key: 'unit',
      align: 'center',
      width: 100

    },{
          title: '退货数量',
          dataIndex : 'qty',
          key: 'qty',
          align: 'center',
          width: 100,
          scopedSlots: { customRender: 'outSlot'}

      },{
      title: '操作',
      align: 'center',
      dataIndex : 'id',
      key: 'Operate',
      width: 80,
      scopedSlots: { customRender: 'Operate'}
    }
  ]
  let columns = [
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '生产批号',
      dataIndex: 'batchNo',
      key: 'batchNo',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '有效期',
      dataIndex: 'validDate',
      key: 'validDate',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 90
    },
    {
      title: '供应商',
      dataIndex: 'supplier',
      key: 'supplier',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 180
    },
    {
      title: '入库单号',
      dataIndex: 'docNo',
      key: 'docNo',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '入库分类',
      dataIndex: 'typeName',
      key: 'typeName',
      align: 'center',
      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text;
      },
      width: 120
    },
    {
      title: '库存',
      dataIndex: 'currQty',
      key: 'currQty',
      align: 'center',

      customRender: (text, record, index) => {
        return text == null || text == undefined ? '-' : text.toFixed(0);;
      },
      width: 120
    },]

</script>

<style scoped>
    .drugSpan{
        padding-bottom: 16px;
        color: #fe6e6e;
        width: 80%;
    }
</style>
